import React from "react";
import { View, StyleSheet } from "react-native";
import { Colors } from "styled42/config";

const progressBarStateEnum = {
  Done: "Done",
  InProgress: "InProgress",
  Pending: "Pending"
};

const ProgressBarComponent = ({ progressStatus, maxValue }) => {
  return (
    <View style={styles.progressBarContainer}>
      {[...new Array(maxValue)].map((_, index) => (
        <ProgressBar
          key={index}
          index={index + 1}
          progressStatus={progressStatus}
        />
      ))}
    </View>
  );
};

const ProgressBar = ({ index, progressStatus }) => {
  let state = progressBarStateEnum.Pending;
  if (index < progressStatus) {
    state = progressBarStateEnum.Done;
  } else if (index === progressStatus) {
    state = progressBarStateEnum.InProgress;
  }
  return (
    <View style={styles.emptyProgressBarStyle}>
      {state !== progressBarStateEnum.Pending && (
        <View
          style={[
            styles.progressStyle,
            state === progressBarStateEnum.InProgress ? styles.flexGrow : null
          ]}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  progressBarContainer: {
    flexDirection: "row",
    justifyContent: "space-evenly",
    marginTop: 8
  },
  emptyProgressBarStyle: {
    flexDirection: "row",
    height: 4,
    width: "22%",
    backgroundColor: Colors.BlueGrey[2]
  },
  progressStyle: { flex: 1, backgroundColor: "#09B885" },
  flexGrow: {
    flexGrow: 0.2
  }
});

export default ProgressBarComponent;
